import { User } from '../../shared/user.model';
import { AuthActionTypes, All } from '../actions/auth.actions';

export interface State {
  // is a user authenticated?
  isAuthenticated: boolean;
  // if authenticated, there should be a user object
  user: User | null;
  // error message
  errorMessage: string | null;

  statusChecked: boolean;
}

export const initialState: State = {
  isAuthenticated: false,
  user: null,
  errorMessage: null,
  statusChecked: false
};

export function reducer(state = initialState, action: All): State {
  switch (action.type) {
    case AuthActionTypes.LOGIN_SUCCESS: {
      return {
        ...state,
        isAuthenticated: true,
        user: {
          token: action.payload.token
        },
        errorMessage: null
      };
    }
    case AuthActionTypes.LOGIN_FAILURE: {
      return {
        ...state,
        errorMessage: 'Incorrect email and/or password.'
      };
    }
    case AuthActionTypes.STATUS_SUCCESS: {
      return {
        ...state,
        isAuthenticated: true,
        user: {
          token: action.payload.token,
          username: action.payload.user ? action.payload.user.username : '',
          name: action.payload.user ? action.payload.user.name : '',
          roles: action.payload.user ? action.payload.user.roles : [],
          _id: action.payload.user ? action.payload.user._id : null
        },
        statusChecked: true,
        errorMessage: null
      };
    }
    case AuthActionTypes.STATUS_FAILURE: {
      return {
        ...state,
        errorMessage: null,
        statusChecked: true
      };
    }
    case AuthActionTypes.LOGOUT: {
      return initialState;
    }
    default: {
      return state;
    }
  }
}
